import { GridCellParams, GridColDef, GridColumnVisibilityModel, GridRowParams, GridActionsCellItem, GridValidRowModel } from '@mui/x-data-grid-premium';
import { Order } from "src/interfaces/enums";
import { initialFilterProps } from "src/interfaces/tables/tables";
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import CustomButton from "src/components/atoms/buttons/CustomButton";
import HistoryIcon from '@mui/icons-material/History';
import clsx from "clsx";
import RestoreIcon from '@mui/icons-material/Restore';
import { SvgIconProps } from '@mui/material';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import CancelIcon from '@mui/icons-material/Cancel';
import RemoveShoppingCartIcon from '@mui/icons-material/RemoveShoppingCart';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import BlockIcon from '@mui/icons-material/Block';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import DraftsIcon from '@mui/icons-material/Drafts';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import EventIcon from '@mui/icons-material/Event'; // For "ItemsExpected"
import AssessmentIcon from '@mui/icons-material/Assessment'; // For "ItemsAssessed"
import DoneAllIcon from '@mui/icons-material/DoneAll'; // For "ItemsCompleted"
import InboxIcon from '@mui/icons-material/Inbox'; // For "ItemsReceived"
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox'; // For "Empty"
import DoneIcon from '@mui/icons-material/Done'; // For "ItemsCompletedPartially"
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import LocalShippingTwoToneIcon from '@mui/icons-material/LocalShippingTwoTone';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import { Box, Divider, Typography } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import StopCircleIcon from '@mui/icons-material/StopCircle';
import TaskIcon from '@mui/icons-material/Task';
import PendingIcon from '@mui/icons-material/Pending';
import PendingOutlinedIcon from '@mui/icons-material/PendingOutlined';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import { tableSettingsProps } from 'src/hooks/table/tableSettings/useTableSettings';


import { Tooltip } from '@mui/material';
import { DarkTheme } from 'src/theme/DarkTheme';
import { yellow } from '@mui/material/colors';
import { SA } from 'country-flag-icons/react/3x2';

// Define a type for the status configuration
type StatusConfig = {
  text: string;
  Icon: React.ElementType<SvgIconProps>;
  color: string;
};

// Define short color constants
const success = DarkTheme.palette.success.main;
const warning = DarkTheme.palette.warning.main;
const error = DarkTheme.palette.error.main;
const info = DarkTheme.palette.info.main;
const gray = DarkTheme.palette.grey[500];

const STATUSES ={
  SALES_ORDERS: ["Fulfilled","Fulfilling","Pending","Cancelled","Processing","Shipped","Delivered","Returned","Completed"],
  PRODUCTS: ["Active","Inactive","Discontinued",],
  SALES_ITEMS: ["Active","Inactive","Discontinued",],
  TRANSFER_ORDERS: ["InTransit", "Completed", "Cancelled", "Draft", ],
  PURCHASE_ORDERS: ["On Draft","Created","Confirmed","Sent","ReceivedShort","InProgress","Changed","InTransit","Ready For Dispatch"],

}

const STATUS_CONFIGS: StatusConfig[] = [
  { text: 'Success', Icon: CheckCircleIcon, color: success },
  { text: 'Error', Icon: ErrorIcon, color: error },
  { text: 'Warning', Icon: WarningIcon, color: warning },
  { text: 'Active', Icon: CheckCircleIcon, color: success },
  { text: 'Inactive', Icon: PauseCircleOutlineIcon, color: warning },
  { text: 'Discontinued', Icon: RemoveShoppingCartIcon, color: error },
  { text: 'Enabled', Icon: CheckCircleIcon, color: success },
  { text: 'Disabled', Icon: BlockIcon, color: error },
  { text: 'Cancelled', Icon: CancelIcon, color: error },
  { text: 'Pending', Icon: HourglassEmptyIcon, color: warning },
  { text: 'Requested', Icon: HourglassEmptyIcon, color: warning },
  { text: 'Processing', Icon: AutorenewIcon, color: info },
  { text: 'Shipped', Icon: LocalShippingIcon, color: info },
  { text: 'Delivered', Icon: CheckCircleIcon, color: success },
  { text: 'Returned', Icon: AssignmentReturnIcon, color: error },
  { text: 'Completed', Icon: CheckCircleIcon, color: success },
  { text: 'Create Shipment Failed', Icon: ErrorIcon, color: error },
  { text: 'Fulfilling', Icon: HourglassEmptyIcon, color: info },
  { text: 'Dispatching', Icon: LocalShippingIcon, color: info },
  { text: 'Fulfilled', Icon: CheckCircleIcon, color: success },
  { text: 'WaitingForPayment', Icon: MoneyOffIcon, color: warning },
  { text: 'Draft', Icon: DraftsIcon, color: info },
  { text: 'New', Icon: DraftsIcon, color: info },
  { text: 'ItemsExpected', Icon: EventIcon, color: info },
  { text: 'ItemsCancelled', Icon: CancelIcon, color: error },
  { text: 'ItemsAssessed', Icon: AssessmentIcon, color: info },
  { text: 'ItemsCompleted', Icon: CheckCircleIcon, color: success },
  { text: 'ItemsReceived', Icon: InboxIcon, color: info },
  { text: 'Empty', Icon: IndeterminateCheckBoxIcon, color: error },
  { text: 'ItemsCompletedPartially', Icon: DoneIcon, color: warning },
  { text: 'On Draft', Icon: DraftsIcon, color: info },
  { text: 'Created', Icon: AddCircleOutlineIcon, color: info },
  { text: 'Confirmed', Icon: ThumbUpOutlinedIcon, color: info },
  { text: 'Sent', Icon: DraftsIcon, color: warning },
  { text: 'ReceivedShort', Icon: InboxIcon, color: error },
  { text: 'InProgress', Icon: HourglassEmptyIcon, color: info },
  { text: 'Changed', Icon: EditIcon, color: info },
  { text: 'InTransit', Icon: LocalShippingIcon, color: info },
  { text: 'Ready For Dispatch', Icon: LocalShippingTwoToneIcon, color: success },
  { text: "Waiting To Be Utilized", Icon: RequestQuoteOutlinedIcon, color: warning },
  { text: "Waiting For Payment", Icon: HourglassEmptyIcon, color: warning },
  { text: 'Utilized Complete', Icon: CheckCircleIcon, color: success },
  { text: "Utilized In Part", Icon: CheckCircleIcon, color: warning },
  { text: "Credited Part", Icon: CheckOutlinedIcon, color: warning },

  { text: "Verification In Progress", Icon: PendingOutlinedIcon, color: warning },
  { text: "Quantities Withdrawn", Icon: ExitToAppOutlinedIcon, color: error },
  { text: "Verified", Icon: CheckCircleIcon, color: success },
  { text: "Paid Complete", Icon: CheckCircleIcon, color: success },
  { text: "Paid Part", Icon: CheckCircleIcon, color: warning },
  { text: "Credited Complete", Icon: CheckOutlinedIcon, color: success },

  { text: 'Creating Picking List', Icon: AutorenewIcon, color: info },
  { text: 'Dispatched', Icon: CheckCircleIcon, color: success },
  { text: 'Verification On Hold', Icon: PauseCircleOutlineIcon, color: warning },
  { text: 'Dispatch Failed', Icon: ErrorIcon, color: error },
  { text: 'Create Picking List Failed', Icon: ErrorIcon, color: error },

  //Post Failed
  { text: 'Post Failed', Icon: ErrorIcon, color: error },
  { text: 'Closed', Icon: TaskIcon, color: gray },
];

// Render function for the status column

const renderStatusCell = (params) => {
  if (!params) return null;
  if (params.rowNode?.isAutoGenerated) return;
  if (params?.value == null || typeof params.value != 'string') return params.value;
  const statusConfig = STATUS_CONFIGS.find(config => config?.text?.toLowerCase() == params?.value?.toLowerCase());

  if (statusConfig) {
    const { Icon, color, text } = statusConfig;
    return (
      <Tooltip title={text}>
        <Icon style={{ color }} />
      </Tooltip>
    );
  }

  return (
    <Tooltip title={params.value}>
      <>{params.value}</>
    </Tooltip>
  );
};



const defaultOptions = {
  significantDigits: 2,
  thousandsSeparator: ',',
  decimalSeparator: '.',
  symbol: ''
}

const buttonColumn = (
  params: GridRowParams | any,
  type: string,
  baseUrl?: string,
  keyName?: string,
  tooltipText?: string,
  openInNewTab: boolean = false,
) => {
  if (!params || params.id == "auto-generated-group-footer-root") return [];

  const icon =
    type == "Edit" ? <EditIcon /> :
    type == "Delete" ? <DeleteIcon /> :
    <VisibilityIcon />;

  const id = keyName
    ? (keyName.includes("_")
        ? params.row?.[keyName.split("_")[0]]?.[keyName.split("_")[1]]
        : params.row?.[keyName])
    : params.id;

  return [
    <CustomButton
      key={params.row?.Id + "_" + type}
      iconButton={true}
      icon={icon}
      tooltipText={tooltipText ?? type}
      actionUrl={baseUrl + id}
      target={openInNewTab ? "_blank" : "_self"}
    />,
  ];
};


function DiscardChangesButton(tableSettings, params, index) {
  const { hasUnsavedRows, discardRowChanges, changedRowsRef } = tableSettings;

  if (!hasUnsavedRows || params.id == "auto-generated-group-footer-root") {
    return <></>;
  }

  const isRowChanged = changedRowsRef.current.some(row => {
    const rowId = getRowIdFromPath(row, tableSettings?.idPath);
    return rowId == params.id;
  });

  return (
    <GridActionsCellItem
      icon={<RestoreIcon />}
      label="Discard changes"
      key={index}
      disabled={!isRowChanged}
      onClick={() => discardRowChanges(params.id)}
    />
  );
}


const revertButton = (params: GridRowParams, editedRowIds, getApiRef) => {
  if (!params || params.id == "auto-generated-group-footer-root") return null;
  const revertChanges = (rowId) => {
    const apiRef = getApiRef();
    if (apiRef && apiRef.current) {
      const editRowsModel = apiRef.current.getEditRowsModel();
      delete editRowsModel[rowId];
      apiRef.current.setEditRowsModel(editRowsModel);
    }
  };

  return (<div key={params.id}>{editedRowIds?.length > 0 ?
    <CustomButton key={params.row?.Id}
      iconButton={true}
      disabled={!editedRowIds.includes(params.id.toString())}
      icon={<HistoryIcon></HistoryIcon>}
      tooltipText={"Undo changes"}
      onClick={() => {
        revertChanges(params.id);
      }}
    /> : null} </div>);
};



const statusColumn = (params: GridCellParams<any, any, any, any>) => {
  if (!params || params.value == null) {
    return '';
  }
  return clsx('status', {
    red: params.value === 'Inactive',
    green: params.value === 'Active',
    grey: params.value === 'Discontinued',
  });
};



const currencyFormatter = (value: number, options: { significantDigits?: number; thousandsSeparator?: string; decimalSeparator?: string; symbol?: string } = {}) => {
  if (typeof value !== 'number') value = 0.0;
  const defaultOptions = {
    significantDigits: 2,
    thousandsSeparator: ',',
    decimalSeparator: '.',
    symbol: 'kr'
  };
  options = { ...defaultOptions, ...options };
  value = parseFloat(value.toFixed(options.significantDigits));

  const [currency, decimal] = value.toString().split('.');
  return `${currency.replace(/\B(?=(\d{3})+(?!\d))/g, options.thousandsSeparator)}${options.decimalSeparator}${decimal ?? '00'} ${options.symbol}`;
};


const getCurrency = (value) => {
  if (value === undefined || value === null) {
    return '';
  }
  return currencyFormatter(value, {});
};


const getDateColumn = (value) => {
  if (value == null || value === undefined || value === '') {
    return null;
  }
  return new Date(value);
};

const getSelectOptions = (data: any, field: string) => {
  if (Array.isArray(data)) {
    return Array.from(
      new Set(data.map(item => item?.[field]))
    ).filter(val => val != null);
  }
  console.warn("getSelectOptions: Expected array but got", data);
  return [];
};



const getFieldKeyOrValue = (value, row, column, apiRef): any => {

  // Ensure params exists to avoid destructuring undefined
  if (!row) {
    return "";
  }
  // Ensure field exists before processing
  if (!column) {
    //console.error("Field is missing in params:", params); 
    return "";
  }

  const fieldAndType = column.field?.split("_");
  const baseField = fieldAndType[0];
  const type = fieldAndType[1];
  const nested = fieldAndType[2];

  let result: any = "";

  if (row?.[baseField] != null) {
    if (row[baseField]?.[type] != null) {
      if (row[baseField][type]?.[nested] != null) {
        result = row[baseField][type][nested] || "";
      } else {
        result = row[baseField][type] || "";
      }
    } else if (row[baseField] != null && (type == null || type === undefined)) {
      result = row[baseField] || "";
    }
  }

  return result ?? "";
};



const getSelectOptionsFromKeyValuePair = (
  data: any,
  field: string
) => {
  if (!Array.isArray(data)) {
    console.warn("getSelectOptionsFromKeyValuePair: Expected an array, got:", data);
    return [];
  }

  return Array.from(
    new Set(
      data
        .map(item => item?.[field]?.Value) // safely access field.Value
        .filter(val => val != null)        // remove null/undefined
    )
  );
};


const getDataGridUrlFilter = (): initialFilterProps => {
  const queryString = require('query-string');
  const urlSearchParams = queryString.parse(location.search);
  const field = urlSearchParams?.field ?? null;
  const value = urlSearchParams?.value ?? null;
  const operator = urlSearchParams?.operator ?? 'contains';
  const searchFilter = { field: field, operator: operator, value: value, id: Math.floor(Math.random() * 1000000) };
  return searchFilter;
}

const getInitalVisibleColumns = (headerColumns: GridColDef[]): GridColumnVisibilityModel => {
  let visibilityModel = {};
  Object.values(headerColumns).forEach(column => {
    visibilityModel = { ...visibilityModel, ...{ [column.field]: true } };
  });
  return visibilityModel;
}

function optionToLabel(optionsArray, row: any, fieldName: string): string {
  const fieldValue = row[fieldName];
  const matchedOption = optionsArray.find(option => option.value === fieldValue);
  return matchedOption ? matchedOption.label : "";
}


const applyFilters = (serachColumns, nameQuery: string, tableData?: any[]): any[] => {
  return tableData?.filter((tableItem) => {
    let matches = true;
    if (nameQuery) {

      let containsQuery = false;
      serachColumns.forEach((property) => {
        if (tableItem[property].toLowerCase().includes(nameQuery.toLowerCase())) {
          containsQuery = true;
        }
      });
      if (!containsQuery) {
        matches = false;
      }
    }

    return matches;
  });
};
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}
function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}



const applySort = (tableData: any[], order: Order, orderBy: string): any[] => {
  const sortedTableData = tableData?.sort(getComparator(order, orderBy))
  return sortedTableData;
};
const applyPagination = (
  tableData: any[],
  page: number,
  limit: number
): any[] => {
  return tableData?.slice(page * limit, page * limit + limit);
};
const applySorting = (serachColumns, order: Order, orderBy: string, nameQuery: string, tableData?: any[]): any[] => {
  const filteredTableData = applyFilters(serachColumns, nameQuery, tableData);
  const sortedTableData = applySort(filteredTableData, order, orderBy);
  return sortedTableData;
};

const deleteButton = (params: GridRowParams, setChangedRows, changedRows, tableSettings) => {
  return [
    <CustomButton key={params.row.Id}
      iconButton={true}
      icon={<DeleteIcon />}
      onClick={() => {
        setChangedRows([...removeWithId(changedRows, params.id, tableSettings.idPath)])
      }} />
    ,]
}
const removeWithId = (array, removeId, idFields) => {
  const indexToRemove = array.findIndex((obj) => idFields.length == 2 ? obj[idFields[0]][idFields[1]] === removeId : obj[idFields[0]] === removeId);
  let newArray = [...array]
  if (indexToRemove > -1) {
    newArray.splice(indexToRemove, 1);
  }
  return newArray;
}


const getRowIdFromPath = (row, idPath) => {
  return idPath?.reduce((acc, key) => acc && acc[key], row);
};

const updateRowIdWithPath = (row, id, idPath) => {
  if (idPath.length === 1) {
    row[idPath[0]] = id;
  } else {
    let current = row;
    for (let i = 0; i < idPath.length - 1; i++) {
      if (!current[idPath[i]]) {
        current[idPath[i]] = {};
      }
      current = current[idPath[i]];
    }
    current[idPath[idPath.length - 1]] = id;
  }
};
const findRowByPathId = (rows, id, idPath) => {

  // Check if id is an array
  if (Array.isArray(id)) {
    return id.map(singleId =>
      rows.filter(row => getRowIdFromPath(row, idPath) == singleId)
    ).flat();
  } else {
    return rows.find(row => getRowIdFromPath(row, idPath) == id);
  }
};


const idCell = (params) => {
  if (!params) return null;
  if (params.rowNode && params.rowNode.isAutoGenerated) {
    return params.formattedValue;
  }
  if (params.id == "multi-edit-row") return "Multi Edit";
  return params.value < 0 ? "NEW" : params.formattedValue;
};




export const mergeById = <T,>(a: T[] | null, b: T[] | null, idPath: string | string[]) => {
  if (!a?.length) return b ?? null;
  if (!b?.length) return a;

  const getByPath = (obj: any, path: string | string[]) => {
    if (!obj) return undefined;
    if (typeof path === "string") return obj?.[path];
    return path.reduce((acc: any, key: string) => (acc == null ? acc : acc[key]), obj);
  };

  const map = new Map<any, T>();
  for (const item of a) map.set(getByPath(item, idPath), item);
  for (const item of b) map.set(getByPath(item, idPath), item);
  return Array.from(map.values());
}; 
type MiniCol = {
  field: string;
  headerName: string;
  type?: GridColDef['type'];
  editable?: boolean;
  flex?: number;
  width?: number;

  /** legacy */
  valueGetter?: (value: any, row: any, column: any, apiRef: any) => any;
  valueFormatter?: (value: any, row: any, column: any, apiRef: any) => any;

  /** new: used only for stacked rendering (preferred if provided) */
  displayValueGetter?: (row: any) => React.ReactNode;
};

export function createStackedColumn(top: MiniCol, bottom: MiniCol): GridColDef {
  const id = `${top.field}_${bottom.field}`;
  const flex = top.flex ?? bottom.flex;
  const width = top.width ?? bottom.width;

  return {
    field: id,
    headerName: `${top.headerName}\n${bottom.headerName}`,
    ...(flex != null ? { flex } : {}),
    ...(width != null ? { width } : {}),
    type: top.type ?? bottom.type,
    editable: top.editable ?? bottom.editable,
    renderHeader: () => (
      <Box sx={{ lineHeight: 1.2, textAlign: 'center', whiteSpace: 'normal' }}>
        <div>{top.headerName}</div>
        <div>{bottom.headerName}</div>
      </Box>
    ),
    renderCell: (params: GridCellParams) => {
      // Prefer displayValueGetter (new), otherwise fall back to legacy valueGetter/raw
      const a =
        typeof top.displayValueGetter === 'function'
          ? top.displayValueGetter(params.row)
          : top.valueGetter
          ? top.valueGetter(params.row[top.field], params.row, { field: top.field } as any, null)
          : params.row[top.field];

      const b =
        typeof bottom.displayValueGetter === 'function'
          ? bottom.displayValueGetter(params.row)
          : bottom.valueGetter
          ? bottom.valueGetter(params.row[bottom.field], params.row, { field: bottom.field } as any, null)
          : params.row[bottom.field];

      return (
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%', py: 1 }}>
          <Typography variant="body2" noWrap>{a}</Typography>
          <Divider sx={{ width: '100%', my: 0 }} />
          <Typography variant="body2" noWrap>{b}</Typography>
        </Box>
      );
    },
  };
}



export const getRowsFromTableSettings = (tableSettings?: tableSettingsProps): any[] => {
  const api = tableSettings?.apiRef?.current;
  if (!api) return [];

  const rowModels = api.getRowModels?.();
  if (!rowModels) return [];

  return Array.from(rowModels.values()).filter((row: any) => !row?.deleted);
};

const TableHelper = {
  deleteButton,
  DiscardChangesButton,
  removeWithId,
  getSelectOptions,
  buttonColumn,
  statusColumn,
  applyPagination,
  applySorting,
  getInitalVisibleColumns,
  getDataGridUrlFilter,
  getSelectOptionsFromKeyValuePair,
  getFieldKeyOrValue,
  getCurrency,
  getDateColumn,
  revertButton,
  optionToLabel,
  getRowIdFromPath,
  updateRowIdWithPath,
  findRowByPathId,
  idCell,
  renderStatusCell,
  createStackedColumn,
  mergeById,
  STATUSES,
  getRowsFromTableSettings
};

export default TableHelper;
